<template>
  <DatatableReportV3
    ref="report"
    :source="source"
    :config="config"
    :filters="filters"
    title="Out of Coverage Area"
    use-datatable-export-csv
  >
    <template #actions>
      <slot name="actions">
        <a
          href="/interested_customers/new"
          class="flex overflow-hidden gap-2 justify-center items-center px-5 py-2.5 !rounded-lg border text-white bg-blue-700 border-blue-700 hover:bg-blue-800"
        >
          <i class="fa fa-plus fa-fw"></i> Add Interested Customer
        </a>
      </slot>
    </template>
  </DatatableReportV3>
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[0, "desc"]],
        columns: [
          {
            data: "date_added",
            title: "Date Added",
            width: 150,
            searchable: false
          },
          { data: "zip_code", title: "Zip code" },
          { data: "email", title: "Email" },
          { data: "phone", title: "Phone" },
          {
            data: "actions",
            title: "Actions",
            sortable: false,
            searchable: false
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Out of Coverage Area" });
  }
};
</script>

<style lang="scss" scoped></style>
